import React from 'react';
import { Text } from 'pcln-design-system';
import styled from 'styled-components';
const StyledPinLabel = /*#__PURE__*/styled(Text).withConfig({
  displayName: "SinglePinLabel__StyledPinLabel",
  componentId: "sc-1xxf5ir-0"
})(["max-width:140px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:box;line-clamp:2;box-orient:vertical;text-shadow:-1px -1px 0 #ffffff,1px -1px 0 #ffffff,-1px 1px 0 #ffffff,1px 1px 0 #ffffff;-webkit-text-stroke:3px #fff;-webkit-text-fill-color:#0068ef;letter-spacing:0.2px;paint-order:stroke fill;"]);
export const SinglePinLabel = props => {
  const {
    name
  } = props;
  return React.createElement(StyledPinLabel, {
    bold: true,
    ml: 2,
    color: 'primary.base',
    size: 1
  }, name);
};